export const EVENT_TYPES = {
  call: "call",
  offer: "offer",
  sms: "smssendevent",
  email: "emailsendevent",
  directEmail: "directemailsendevent",
  emailReceiveEvent: "emailreceiveevent",
  fileUpload: "fileupload",
  note: "note",
  taskEvent: "taskevent",
  meeting: "meeting",
  feedback: "feedbackevent",
  bookingReschedule: "bookingrescheduleevent",
}

export const TASK_EVENT_TYPES = {
  created: "created",
  markedDone: "marked_done",
  unmarkedDone: "unmarked_done",
}

export const GLOBAL_SEARCH_URL_PARAMS = {
  emailTransaction: "emtid",
  sms: "smid",
  offer: "ofid",
  meeting: "mtid",
  call: "clid",
  note: "ntid",
}
